import { HttpErrorResponse } from '@angular/common/http';

export const FOOD_CERT_PREVIOUS_ORDER_ALREADY_RENEWED_ERROR = 'PREVIOUS_ORDER_ALREADY_RENEWED';

/**
 * Reads the food-cert recertify error code from an HTTP error body.
 * @param error
 */
export function extractFoodCertRecertifyErrorCode(error: Readonly<HttpErrorResponse>): string {
  const body = error.error;

  if (typeof body === 'string') {
    return body.trim();
  }

  if (body && typeof body === 'object') {
    const { message } = body as { message?: unknown };

    if (typeof message === 'string') {
      return message.trim();
    }
  }

  return '';
}

/**
 * Whether the HTTP error is a duplicate-renew conflict from order-draft recertify.
 * @param error
 */
export function isFoodCertPreviousOrderAlreadyRenewedError(error: Readonly<HttpErrorResponse>): boolean {
  return extractFoodCertRecertifyErrorCode(error) === FOOD_CERT_PREVIOUS_ORDER_ALREADY_RENEWED_ERROR;
}
